var _defs, _ellipse, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoapRollDispenserYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.26 327.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #ffce4a;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        stroke-width: .75px;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #ff942b;\r\n      }\r\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 108.13,
    cy: 106.13,
    rx: 90,
    ry: 91.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.27,142.12s-.99,67.35,2.96,78.62c3.93,11.24,8.84,33.7,8.87,43.64,0,.05,0,.09.01.14.31,1.44,5.71,26.36,8.83,32.32.02.04.03.07.05.11l9.42,29.47c.22.67,1.07.66,1.27-.02l1.23-4.28c.08-.29.32-.5.59-.52l5.64-.47c.32-.03.58-.31.62-.67l.66-7.14c.01-.13.06-.26.13-.37l1.22-1.82c.09-.14.14-.31.13-.48l-.23-6.56c0-.21.06-.41.2-.56l4.04-4.51c.12-.13.19-.31.2-.5l.21-5.5c.01-.32.21-.59.48-.69l2.94-.96c.41-.13.6-.65.4-1.06-1.5-3.18-6.95-15.09-8.23-23.36,0-.02,0-.03,0-.05-.09-.89-2.55-24.35-7.39-47.81l-3.69-19.48s0-.05-.01-.07l-.44-18.63c-.05-.12-.13-.3-.26-.51-.52-.84-1.27-1.2-1.7-1.45-.06-.03-.76-.64-2.15-1.86-1.85-1.62-4.01-3.64-4.74-4.35-4.36-4.2-9.3-10.79-10.27-12.08-3.26-4.35-5.57-7.44-8.02-12.13-1.36-2.59-2.32-4.83-2.95-6.41Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 109.39,
    cy: 109.87,
    r: 34.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.79,89.39h7.3v40.96h-7.17s-.46-41.28-.13-40.96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoapRollDispenserYellow);
export default __webpack_public_path__ + "static/media/soap_roll_dispenser_yellow.f06c7dd60ec88238da712707a3284ec5.svg";
export { ForwardRef as ReactComponent };